import React, { useState } from "react";
import "./FaqComponent.scss";

const FaqComponent = ({ title = "Frequently Asked Questions", faqs = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <div className="faq-header">
          <h2>{title}</h2>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <div 
                className="faq-question" 
                onClick={() => toggleFaq(index)}
                role="button"
                tabIndex={0}
                aria-expanded={activeIndex === index}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    toggleFaq(index);
                    e.preventDefault();
                  }
                }}
              >
                <h3>{faq.question}</h3>
                <span className="faq-icon">
                  <i className={`fa-solid ${activeIndex === index ? 'fa-minus' : 'fa-plus'}`}></i>
                </span>
              </div>
              <div 
                className="faq-answer"
                aria-hidden={activeIndex !== index}
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              >
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqComponent;
